module.exports = new __parcel__URL__("shop_machines_others_receiver.952ed4f1.png").toString();